











import { defineComponent, watch } from '@nuxtjs/composition-api';
import useCartCookie from '@shared/composables/useCartCookie';
import useShopifyDiscounts from '@shared/composables/useShopifyDiscounts';

import CartFreeGiftProgress from './internal/CartFreeGiftProgress.vue';

export default defineComponent({
  name: 'CartDiscounts',
  components: { CartFreeGiftProgress },
  setup() {
    const { cart } = useCartCookie();
    const { discountProgress, updateCartDiscountProgress } = useShopifyDiscounts();

    watch(
      cart,
      (cart) => {
        updateCartDiscountProgress(cart);
      },
      { immediate: true, deep: true },
    );

    return {
      discountProgress,
    };
  },
});
